package common.dto

import kotlinx.serialization.Serializable
import three.js.Quaternion

/**
 * Dto class for wrapping a quaternion. We use quaternions to represent the rotations of elements.
 *
 * This way, the rotation of added elements can be easily calculated by multiplying the WORLD rotation of the base
 * element with the LOCAL rotation of the added element (relative to the base element).
 *
 * By default, the quaternion is the identity quaternion, i.e. no rotation.
 */
@Serializable
data class Quat(
    val x: Double = 0.0,
    val y: Double = 0.0,
    val z: Double = 0.0,
    val w: Double = 1.0,
) {
    fun sameAs(other: Quaternion): Boolean {
        return x == other.x && y == other.y && z == other.z && w == other.w
    }
}